import IconButton from "../../UI/IconButton/IconButton";

import { ReactComponent as subtitle } from "../../../assets/icons/subtitle.svg";
import { ReactComponent as restart } from "../../../assets/icons/restart.svg";
import { ReactComponent as soundOff } from "../../../assets/icons/sound-off.svg";
import { ReactComponent as skipNext } from "../../../assets/icons/skip-next.svg";
import { ReactComponent as soundOn } from "../../../assets/icons/sound-on.svg";
import { ReactComponent as next } from "../../../assets/images/cheveron-right.svg";

import "./IntroVideoControl.scss";

export { restart, next, skipNext };

const IntroVideoControl = ({
  handleToggleSubtitles,
  handleToggleMute,
  handleRestart,
  handleSkip,
  isMuted = false,
  isPlaying = true,
  isShowSubtitles = false,
}) => {
  return (
    <div className="intro-video-menu">
      <IconButton
        edge="end"
        color="inherit"
        className="icon"
        aria-label="Profile and achievements"
        onClick={handleToggleSubtitles}
        imageSrc={subtitle}
        title={isShowSubtitles ? "Turn off subtitles" : "Turn on subtitles"}
      />

      <IconButton
        edge="end"
        color="inherit"
        className="icon"
        aria-label="Settings"
        onClick={handleToggleMute}
        imageSrc={isMuted ? soundOff : soundOn}
        title={isMuted ? "Unmute" : "Mute"}
      />

      <IconButton
        edge="end"
        color="inherit"
        className="icon"
        aria-label="Clue board"
        imageSrc={restart}
        onClick={handleRestart}
        title="Restart video"
        disabled={isPlaying}
      />

      <IconButton
        edge="end"
        color="inherit"
        className="icon"
        aria-label="Sign out"
        onClick={handleSkip}
        imageSrc={isPlaying ? skipNext : next}
        title={isPlaying ? "Skip" : "Next"}
      />
    </div>
  );
};

export default IntroVideoControl;
